module.exports = __webpack_public_path__ + "media/images/about-us/works/browse_courses-201095bc8b2cdbf1328ea65bf4e7f7f4.png";